import {Box} from "@mui/material";
import {flagStyles} from "../../../styles/flag.styles";

const Germany = () => (
    <Box
        component="span"
        sx={flagStyles.germany}
    />
);

export default Germany;